import Grid from '@jobseeker/lotus/foundations/Layouts/Grid';
import HeaderWithNav from '@jobseeker/feature-navigation/components/Header/HeaderAuth';

import {ImageholderVariants} from '@jobseeker/lotus/components/ImageHolder/enums';
import {useIsCustomWidth} from '@jobseeker/lotus/hooks';
import {shallowEqual, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {isCSR} from '@jobseeker/lotus/utils';

import type {HeaderHarnessProps} from '@jobseeker/feature-navigation/components/Header/types';

const isMobile = (belowLg: boolean, device: string) => {
  if (isCSR()) {
    return belowLg;
  } else {
    return device === 'mobile' ? true : false;
  }
};

const HeaderWithAuth = (props: HeaderHarnessProps) => {
  const isTabAndMobile = useIsCustomWidth('lg');
  const {device} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );

  const currentPage = useSelector(
    (state: AppState) => state.app.page,
    shallowEqual
  );

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  return (
    <Grid container spacing={0} justifyContent="space-between">
      <HeaderWithNav
        {...props}
        appBarProps={{
          position: 'fixed',
          color: 'inherit',
          sx: {
            borderBottomLeftRadius: isAppIimjobs ? 16 : 0,
            borderBottomRightRadius: isAppIimjobs ? 16 : 0,
            zIndex: 990,
            boxShadow: 'none',
            top: props.showHiristPromotionBanner
              ? currentPage === 'jobdetail'
                ? '96px'
                : '80px'
              : '0px',
          },
        }}
        container={{
          maxWidth: false,
          sx: {
            maxWidth: '1440px',
            px: isAppIimjobs ? {xxs: 2, md: 2, xxl: 0} : '16px !important',
          },
        }}
        imageProps={{
          variant: ImageholderVariants.WITHLINK,
          imageSpec: {
            src: props.meta.logo,
            alt: process.env.NEXT_PUBLIC_APP_NAME,
            width: !isAppIimjobs
              ? !isMobile(isTabAndMobile, device)
                ? 130
                : 104
              : 85,
            height: !isAppIimjobs
              ? !isMobile(isTabAndMobile, device)
                ? 35
                : 28
              : 34,
            loading: 'eager',
          },
          imgStyle: {
            maxWidth: !isAppIimjobs ? '130px' : '95px',
          },
          linkProps: {
            href: '/',
          },
        }}
        isMobileDevice={isMobile(isTabAndMobile, device)}
        showMenu={true}
        showExploreJobs={props.page.includes('registration-') ? true : false}
        showMenuSelect={['jobfeed'].includes(props?.page) ? true : false}
        data-testid="header-auth"
      />
    </Grid>
  );
};

export default HeaderWithAuth;
